import { render, staticRenderFns } from "./NationalIDCard.vue?vue&type=template&id=76e5e4e8&scoped=true&"
import script from "./NationalIDCard.vue?vue&type=script&lang=js&"
export * from "./NationalIDCard.vue?vue&type=script&lang=js&"
import style0 from "./NationalIDCard.vue?vue&type=style&index=0&id=76e5e4e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e5e4e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VCol,VContainer,VOverlay,VProgressCircular,VRow,VSheet})
